import { Raritygems } from "./RarityGems";
import { GreenButton, StyledPunkCard } from "./Styled";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import { ethers } from "ethers";
import dayjs from "dayjs";

const PunkCard = ({ punk, className = "", listPage = false }) => {
  const history = useHistory();

  return (
    <StyledPunkCard
      className={clsx(`rounded-xl overflow-hidden relative`, className)}
    >
      {punk.onSale && (
        <span
          className="price absolute left-0 top-0 p-1 text-sm rounded-sm"
          style={{ background: "#e74c3c" }}
        >
          {ethers.utils.formatEther(punk.info.price.toString()).toString()}ETH
        </span>
      )}
      <span
        className="bottom-O left-O absolute text-sm p-1 rounded-sm"
        style={{
          background: "#e74c3c",
          position: "absolute",
          left: "0",
          bottom: "0",
        }}
      >
        {punk.onSale ? `On sale` : "Not listed"}
      </span>
      {punk.onSale && (
        <span className="top-0 right-0 absolute pr-2">
          {dayjs(punk.info.listingTime.toString() * 1000).format(
            "YYYY-MM-DD HH:mm"
          )}
        </span>
      )}

      <div className="block w-full mb-4 image_box">
        <img src={punk.image} alt="punk" className="block w-full rounded-xl" />
      </div>
      <div>
        <ul className="text-sm ">
          <li className="mt-2">{punk.name}</li>
          <li className="mt-2">Rank: {punk.rank}</li>
          <li className="mt-2">
            Rarity: <Raritygems rarity={punk.rank} />
          </li>
          <li></li>
          <li className="mt-2">
            Traits:
            <ul className="text-left flex flex-wrap">
              {punk.traits.map((trait) => (
                <li className="inline-block trait w-1/2">
                  {trait.trait_value}
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
      {punk.id !== null && listPage && (
        <div className="flex flex-center mt-4">
          <GreenButton
            className="mx-auto"
            onClick={() => {
              history.push(`/detail/${punk.id}`);
            }}
          >
            details
          </GreenButton>
        </div>
      )}
    </StyledPunkCard>
  );
};
export default PunkCard;
